import { render } from "./SettingPassword.vue?vue&type=template&id=30fce265&scoped=true"
import script from "./SettingPassword.vue?vue&type=script&lang=js"
export * from "./SettingPassword.vue?vue&type=script&lang=js"

import "./SettingPassword.vue?vue&type=style&index=0&id=30fce265&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fce265"]])

export default __exports__